module.exports = __webpack_public_path__ + "img/0-10.05dd2d02.gif";